/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import updateSources from './components/update-sources';
import ProductMailAlert from './components/product-mail-alert';

let swiperThumb = null;
let swiperThumbModal = null;

$(document).ready(() => {
  function coverImage() {
    const productCover = $(prestashop.themeSelectors.product.cover);
    const modalProductCover = $(prestashop.themeSelectors.product.modalProductCover);
    let thumbSelected = $(prestashop.themeSelectors.product.selected);

    const swipe = (selectedThumb, thumbParent) => {
      const newSelectedThumb = thumbParent.find(prestashop.themeSelectors.product.thumb);
      const idSelectedThumb = thumbParent.data('id');
      const newSelectedThumbModal = $(prestashop.themeSelectors.product.imagesModal).find('.js-modal-thumb[data-id="' + idSelectedThumb + '"]');

      // Swap active classes on thumbnail
      selectedThumb.removeClass('selected');
      selectedThumb.parent().parent().removeClass('js-selected');
      newSelectedThumb.addClass('selected');
      newSelectedThumb.parent().parent().addClass('js-selected');

      $(prestashop.themeSelectors.product.imagesModal).removeClass('selected');
      $('.js-product-images-modal .thumb-container').removeClass('js-selected');
      $(newSelectedThumbModal).addClass('selected');
      $(newSelectedThumbModal).parent().parent().addClass('js-selected');

      // Update sources of both cover and modal cover
      modalProductCover.prop('src', newSelectedThumb.data('image-large-src'));
      productCover.prop('src', newSelectedThumb.data('image-large-src'));

      // Get data from thumbnail and update cover src, alt and title
      productCover.attr('title', newSelectedThumb.attr('title'));
      modalProductCover.attr('title', newSelectedThumb.attr('title'));
      productCover.attr('alt', newSelectedThumb.attr('alt'));
      modalProductCover.attr('alt', newSelectedThumb.attr('alt'));

      // Get data from thumbnail and update cover sources
      updateSources(productCover, newSelectedThumb.data('image-large-sources'));
      updateSources(modalProductCover, newSelectedThumb.data('image-large-sources'));
    };

    const swipeModal = (selectedThumb, thumbParent) => {
      const newSelectedThumb = thumbParent.find('.js-modal-thumb');

      // Swap active classes on thumbnail
      selectedThumb.removeClass('selected');
      newSelectedThumb.addClass('selected');

      selectedThumb.parent().parent().removeClass('js-selected');
      newSelectedThumb.parent().parent().addClass('js-selected');

      // Update sources of both cover and modal cover
      modalProductCover.prop('src', newSelectedThumb.data('image-large-src'));

      // Get data from thumbnail and update cover src, alt and title
      modalProductCover.attr('title', newSelectedThumb.attr('title'));
      modalProductCover.attr('alt', newSelectedThumb.attr('alt'));

      // Get data from thumbnail and update cover sources
      updateSources(modalProductCover, newSelectedThumb.data('image-large-sources'));
    };

    $(prestashop.themeSelectors.product.thumb).on('click', (event) => {
      thumbSelected = $(prestashop.themeSelectors.product.selected);
      swipe(thumbSelected, $(event.target).closest(prestashop.themeSelectors.product.thumbContainer));
    });

    $(prestashop.themeSelectors.product.thumbModal).on('click', (event) => {
      thumbSelected = $(prestashop.themeSelectors.product.modalSelected);
      swipeModal(thumbSelected, $(event.target).closest(prestashop.themeSelectors.product.thumbContainer));
    });

    $('.sld-js-scroll-next').on('click', () => {
      thumbSelected = $(prestashop.themeSelectors.product.selected);
      const thumbNext = thumbSelected.first().closest('.swiper-slide').next();

      if (thumbNext.length > 0) {
        swipe(thumbSelected, thumbNext);
      }
    });

    $('.sld-js-scroll-prev').on('click', () => {
      thumbSelected = $(prestashop.themeSelectors.product.selected);
      const thumbPrev = thumbSelected.first().closest('.swiper-slide').prev();

      if (thumbPrev.length > 0) {
        swipe(thumbSelected, thumbPrev);
      }
    });

    $('.sld-js-scroll-modal-next').on('click', () => {
      thumbSelected = $(prestashop.themeSelectors.product.modalSelected);
      const thumbNext = thumbSelected.first().closest('.swiper-slide').next();

      if (thumbNext.length > 0) {
        swipeModal(thumbSelected, thumbNext);
      }
    });
    $('.sld-js-scroll-modal-prev').on('click', () => {
      thumbSelected = $(prestashop.themeSelectors.product.modalSelected);
      const thumbPrev = thumbSelected.first().closest('.swiper-slide').prev();

      if (thumbPrev.length > 0) {
        swipeModal(thumbSelected, thumbPrev);
      }
    });

    productCover.swipe({
      swipe: (event, direction) => {
        thumbSelected = $(prestashop.themeSelectors.product.selected);
        const parentThumb = thumbSelected.closest(prestashop.themeSelectors.product.thumbContainer);

        if (direction === 'right') {
          if (parentThumb.prev().length > 0) {
            swipe(thumbSelected, parentThumb.prev());
          } else if (parentThumb.next().length > 0) {
            swipe(thumbSelected, parentThumb.next());
          }
        } else if (direction === 'left') {
          if (parentThumb.next().length > 0) {
            swipe(thumbSelected, parentThumb.next());
          } else if (parentThumb.prev().length > 0) {
            swipe(thumbSelected, parentThumb.prev());
          }
        }
      },
      allowPageScroll: 'vertical',
    });
  }

  function createInputFile() {
    $(prestashop.themeSelectors.fileInput).on('change', (event) => {
      const target = $(event.currentTarget)[0];
      const file = (target) ? target.files[0] : null;

      if (target && file) {
        $(target).prev().text(file.name);
      }
    });
  }

  function createProductSpin() {
    const $quantityInput = $(prestashop.selectors.quantityWanted);
    const $quantityInputSticky = $('#quantity_wanted_sticky');

    $quantityInput.TouchSpin({
      verticalbuttons: false,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin btn-icon',
      buttonup_class: 'btn btn-touchspin js-touchspin btn-icon',
      buttondown_txt: '<i class="sld-icon-minus"></i>',
      buttonup_txt: '<i class="sld-icon-plus"></i>',
      min: parseInt($quantityInput.attr('min'), 10),
      max: 1000000,
    });

    $(prestashop.themeSelectors.touchspin).off('touchstart.touchspin');

    $quantityInput.on('focusout', () => {
      if ($quantityInput.val() === '' || $quantityInput.val() < $quantityInput.attr('min')) {
        $quantityInput.val($quantityInput.attr('min'));
        $quantityInput.trigger('change');
      }
    });

    $('body').on('change keyup', prestashop.selectors.quantityWanted, (e) => {
      if ($quantityInput.val() !== '') {
        $(e.currentTarget).trigger('touchspin.stopspin');
        prestashop.emit('updateProduct', {
          eventType: 'updatedProductQuantity',
          event: e,
        });
      }
    });

    $quantityInputSticky.TouchSpin({
      verticalbuttons: false,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin btn-icon',
      buttonup_class: 'btn btn-touchspin js-touchspin btn-icon',
      buttondown_txt: '<i class="sld-icon-minus"></i>',
      buttonup_txt: '<i class="sld-icon-plus"></i>',
      min: parseInt($quantityInput.attr('min'), 10),
      max: 1000000,
    });

    $quantityInputSticky.on('focusout', () => {
      if ($quantityInputSticky.val() === '' || $quantityInputSticky.val() < $quantityInputSticky.attr('min')) {
        $quantityInputSticky.val($quantityInputSticky.attr('min'));
        $quantityInputSticky.trigger('change');
      }
    });

    $('body').on('change keyup', '.js-product-add-to-cart-sticky #quantity_wanted', (e) => {
      if ($quantityInputSticky.val() !== '') {
        $(e.currentTarget).trigger('touchspin.stopspin');
        prestashop.emit('updateProduct', {
          eventType: 'updatedProductQuantity',
          event: e,
        });
      }
    });

    $quantityInputSticky.on('change', () => {
      $quantityInput.val($quantityInputSticky.val());
    });

    $quantityInput.on('change', () => {
      $quantityInputSticky.val($quantityInput.val());
    });
  }

  function addJsProductTabActiveSelector() {
    const nav = $(prestashop.themeSelectors.product.tabs);
    nav.on('show.bs.tab', (e) => {
      const target = $(e.target);
      target.addClass(prestashop.themeSelectors.product.activeNavClass);
      $(target.attr('href')).addClass(prestashop.themeSelectors.product.activeTabClass);
    });
    nav.on('hide.bs.tab', (e) => {
      const target = $(e.target);
      target.removeClass(prestashop.themeSelectors.product.activeNavClass);
      $(target.attr('href')).removeClass(prestashop.themeSelectors.product.activeTabClass);
    });
  }

  const refreshDetails = () => {
    const refSource = document.querySelector('.js-product-reference-source');
    const refDest = document.querySelector('.js-product-reference-dest');

    if (refSource !== null && refDest !== null) {
      refDest.innerHTML = refSource.innerHTML;
    }

    const availabilitySource = document.querySelector('.js-product-availability-source');
    const availabilityDest = document.querySelector('.js-product-availability-dest');

    if (availabilitySource !== null && availabilityDest !== null) {
      availabilityDest.innerHTML = availabilitySource.innerHTML;
    }

    const featuresSource = document.querySelector('.js-product-features-source');
    const featuresDest = document.querySelector('.js-product-features-dest');

    if (featuresSource !== null && featuresDest !== null) {
      featuresDest.innerHTML = featuresSource.innerHTML;
    }

  };

  const fullContainerResize = () => {
    const containers = document.querySelectorAll('.js-full-bg');
    const bodyWidth = document.body.clientWidth;

    if (containers.length > 0) {
      containers.forEach((container) => {
        container.style.position = 'relative';
        container.style.zindex = 0;
        const containerWidth = container.clientWidth;
        let containerBg = container.querySelector('.sld-full-bg');

        if (containerBg === null) {
          containerBg = document.createElement('div');
          containerBg.classList.add('sld-full-bg');
        }
        containerBg.style.left = `-${((bodyWidth - containerWidth) / 2)}px`;
        containerBg.style.width = `${bodyWidth}px`;
        container.append(containerBg);
      });
    }
  };

  function swiperThumbnails() {
    // Destroy
    if (swiperThumb !== null) {
      /*if (typeof swiperThumb.destroy === 'function') {
        swiperThumb.destroy(true, true);
      }*/
      swiperThumb = null;
    }

    let spaceBetween = $('.js-product-images.horizontal').data('max-images');
    if (window.innerWidth <= 1680 && spaceBetween > 6) {
      spaceBetween = 6;
    }
    if (window.innerWidth <= 1500 && spaceBetween >= 6) {
      spaceBetween = 5;
    }
    if (window.innerWidth <= 992 && spaceBetween >= 5) {
      spaceBetween = 4;
    }
    if (window.innerWidth <= 576 && spaceBetween >= 4) {
      spaceBetween = 3.5;
    }

    const maxWidth = spaceBetween * 86;
    $('.js-product-images.horizontal .product-images').css({'max-width' : maxWidth + 'px'});

    swiperThumb = new Swiper('.page-content .js-product-images .swiper', {
      slidesPerView: spaceBetween,
      spaceBetween: 16,
      direction: 'horizontal',
      speed: 100,
      centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: '.sld-js-scroll-next',
        prevEl: '.sld-js-scroll-prev',
      },
    });
  }

  function swiperThumbnailsModal() {
    // Destroy
    if (swiperThumbModal !== null) {
      swiperThumbModal.destroy(true, true);
      swiperThumbModal = null;
    }

    let spaceBetween = $('#product-modal .js-product-images-modal.horizontal').data('max-images');

    if (window.innerWidth <= 1680 && spaceBetween > 6) {
      spaceBetween = 6;
    }
    if (window.innerWidth <= 1500 && spaceBetween >= 6) {
      spaceBetween = 5;
    }
    if (window.innerWidth <= 992 && spaceBetween >= 5) {
      spaceBetween = 4;
    }
    if (window.innerWidth <= 576 && spaceBetween >= 4) {
      spaceBetween = 3.5;
    }

    const maxWidth = spaceBetween * 86;
    $('#product-modal .js-product-images-modal.horizontal .product-images').css({'max-width' : maxWidth + 'px'});

    swiperThumbModal = new Swiper('#product-modal .swiper', {
      slidesPerView: spaceBetween,
      spaceBetween: 16,
      direction: 'horizontal',
      speed: 100,
      centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: '.sld-js-scroll-modal-next',
        prevEl: '.sld-js-scroll-modal-prev',
      },
    });
  }

  function sldMoveProductElements() {
    // JS move element
    const elementSources = Array.from(document.querySelectorAll('.js-move-element'));
    if (elementSources.length) {
      elementSources.forEach(($element) => {
        const destinationSelector = $element.dataset.destination;
        if (destinationSelector) {
          const $destination = document.querySelector(destinationSelector);
          if ($destination) {
            $destination.innerHTML = '';
            //$destination.append($($element).html());
            $destination.innerHTML = $($element).html();
          } else {
            console.warn('[.js-move-element] destination '+destinationSelector+' not found');
          }
        } else {
          console.warn('[.js-move-element] data destination required');
        }
      });
    }
  }

  function sldModalCard() {
    $('body').on('click', '.zoom-decli-card', (e) => {
      const productCover = $(prestashop.themeSelectors.product.cover);
      const modalProductCover = $(prestashop.themeSelectors.product.modalProductCover);
      const decliThumb = $(e.currentTarget).find('img');

      modalProductCover.prop('src', decliThumb.data('full-size-image-url'));
      productCover.prop('src', decliThumb.data('full-size-image-url'));
      modalProductCover.attr('title', decliThumb.attr('title'));
      productCover.attr('title', decliThumb.attr('title'));
      modalProductCover.attr('alt', decliThumb.attr('alt'));
      productCover.attr('alt', decliThumb.attr('alt'));

      $('#product-modal').modal('show');
    });
  }

  function sldShowMobileStandardDeclinaisons() {
    const variants = $('.js-product-variants');
    const variantsTableau = $('#product-decli #wk-combination-footer-view');
    const blockDecli = $('#product-decli');
    const buttonModele = $('#btn-view-models');
    const addToCart = $('#qty-add');
    const avaibilityMobile = $('#product-availability-mobile');
    const caract = $('.product-features');
    if (variants.length > 0 && variantsTableau.length > 0) {
      if (prestashop.responsive.mobile) {
        blockDecli.hide();
        buttonModele.hide();
        variants.removeClass('d-none');
        addToCart.removeClass('d-none');
        avaibilityMobile.removeClass('d-none');
        caract.removeClass('d-none');
      } else {
        blockDecli.show();
        buttonModele.show();
        variants.addClass('d-none');
        addToCart.addClass('d-none');
        avaibilityMobile.addClass('d-none');
        caract.addClass('d-none');
      }
    }
  }

  function refreshProductAvailability(event) {
    const containerProductAvailability= $('.js-product-availability');
    containerProductAvailability.replaceWith(event.product_availability);
  }

  const refreshDataStickyAddToCart = (event) => {
    if (prestashop.responsive.mobile) {
      $('.js-product-add-to-cart-sticky .add-to-cart').on('click', () => {
        $('.js-product-add-to-cart .add-to-cart').click();
      });
    }
  };

  const checkScrollAddToCartSticky = () => {
    const productAddToCart = document.querySelector('.js-product-add-to-cart');
    const productAddToCartSticky = document.querySelector('.js-product-add-to-cart-sticky');
    const $footer = $('#footer');
    const rect = productAddToCart.getBoundingClientRect();

    if (prestashop.responsive.mobile) {
      if (productAddToCart && productAddToCartSticky) {
        if (rect.bottom - 150 <= 0) {
          productAddToCartSticky.classList.add('active');
          $footer.css('padding-bottom', productAddToCartSticky.offsetHeight);
        } else {
          productAddToCartSticky.classList.remove('active');
          $footer.css('padding-bottom', 0);
        }
      }
    } else {
      if (productAddToCartSticky) {
        productAddToCartSticky.classList.remove('active');
        $footer.css('padding-bottom', 0);
      }
    }
  };

  const sldDescription = () => {
    $(document).on('click', '#scroll_product_description', function (e) {
      if (prestashop.responsive.mobile) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        $('.product-description#description').addClass('show');
        $('body').addClass('modal-open');
      } else {
        let anchor = $(".product-description#description").offset().top - $("#header").height();
        $([document.documentElement, document.body]).animate({
          scrollTop: anchor
        }, 1000);
      }
    });

    $(document).on('click', '.product-description-title > .close', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $('.product-description#description').removeClass('show');
      $('body').removeClass('modal-open');
    });

  };

  const syncProductRefreshUrl = (productUrl = null) => {
    if (!prestashop.urls || !prestashop.urls.pages) {
      return;
    }

    if (!prestashop.page || prestashop.page.page_name !== 'product') {
      return;
    }

    // This shop returns a 404 on the generic product controller URL in AJAX POST.
    const normalizedProductUrl = (productUrl || window.location.href).split('#')[0];

    prestashop.urls.pages.product = normalizedProductUrl;
    prestashop.urls.current_url = normalizedProductUrl;
  };


  fullContainerResize();
  refreshDataStickyAddToCart();
  checkScrollAddToCartSticky;
  createProductSpin();
  createInputFile();
  coverImage();
  addJsProductTabActiveSelector();
  swiperThumbnails();
  sldMoveProductElements();
  sldModalCard();
  sldShowMobileStandardDeclinaisons();
  sldDescription();
  syncProductRefreshUrl();
  const productMailAlert = new ProductMailAlert();
  productMailAlert.init();

  $(document).on('click', '#btn-view-models', function (e) {
    e.preventDefault();
    const type = $('#product-decli').data('type');
    let anchor = $("#product-decli table tbody td").first().offset().top - $("#header").height();
    if (type === 'card') {
      // anchor = $("#product-decli .js-product").first().find(".product-quantity").offset().top - $("#header").height();
      anchor = $("#product-decli").offset().top - $("#header").height() + $("#header .header-before").height();
    }
    if (prestashop.responsive.mobile && type === 'table') {
      anchor = $('.js-product-variants').offset().top - $("#header").height();
    }
    $([document.documentElement, document.body]).animate({
      scrollTop: anchor
    }, 1000);
    return;
  });

  $(document).on('click', '.price-4x a', function (e) {
    e.preventDefault();
    $('#alma-block .alma-payment-plans-know-more-action').click();
  });

  $('#product-modal').on('shown.bs.modal', function () {
    swiperThumbnailsModal();
  });

  prestashop.on('updatedProduct', (event) => {
    syncProductRefreshUrl(event && event.product_url ? event.product_url : null);
    refreshDataStickyAddToCart(event);
    createInputFile();
    coverImage();
    refreshDetails();
    swiperThumbnails();
    sldMoveProductElements();
    sldModalCard();
    sldShowMobileStandardDeclinaisons();
    productMailAlert.syncAvailabilityAlert();
    refreshProductAvailability(event);
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = prestashop.selectors.quantityWanted;
      const quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {
        min: minimalProductQuantity,
      });
    }
    $($(prestashop.themeSelectors.product.activeTabs).attr('href')).addClass('active').removeClass('fade');
    $(prestashop.themeSelectors.product.imagesModal).replaceWith(event.product_images_modal);
  });

  window.addEventListener('resize', () => {
    fullContainerResize();
    sldShowMobileStandardDeclinaisons();
    swiperThumbnails();
    checkScrollAddToCartSticky();
    sldDescription();
  });

  window.addEventListener('popstate', () => {
    syncProductRefreshUrl();
  });

  window.addEventListener('scroll', checkScrollAddToCartSticky);
});
